import React from 'react';
import { Typography } from '../typography/typography';
import { Spacer } from '../spacer/spacer';
import { QueryErrorHandler } from '../query-error-handler/query-error-handler';
import styles from './table-layout.module.scss';

type Props = {
  title?: string | null;
  table: React.ReactNode;
  globalActions?: React.ReactNode;
  error?: React.ComponentProps<typeof QueryErrorHandler>['error'];
  debugInfo?: React.ComponentProps<typeof QueryErrorHandler>['debugInfo'];
};

export const TableLayout: React.FC<Props> = ({ title, table, globalActions, error }) => {
  return (
    <>
      {title ? (
        <>
          <div className={styles.title}>
            <Typography variant="headline-2">{title}</Typography>
            <div className={styles.globalActions}>{globalActions}</div>
          </div>
          <Spacer size="04" />
        </>
      ) : null}
      <QueryErrorHandler error={error}>{table}</QueryErrorHandler>
    </>
  );
};
